import React from 'react';
import {DmsTab} from 'Components';
import { hashHistory } from 'react-router';
import {Form, Input, Select, Button, Row, Col} from 'antd';
const Option = Select.Option;
const FormItem = Form.Item;
const {TextArea} = Input;


class Regionadd extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			roleId:this.props.params.roleId,
			opts: ['新建角色'],
			detail:{},
			rows: [
				{
					id: 1,
					name: '系统管理员',
					code: 'admin',
					active: 1,
					description:'系统设置与管理'
				}, {
					id: 2,
					name: '系统管理员',
					code: 'admin',
					active: 1,
					description:'系统设置与管理'
				}, {
					id: 3,
					name: '系统管理员',
					code: 'admin',
					active: 1,
					description:'系统设置与管理'
				},{
					id: 4,
					name: '系统管理员',
					code: 'admin',
					active: 1,
					description:'系统设置与管理'
				}
			]
		}
	}
	
	componentDidMount() {
		//console.log(this.props.location.query.index);
		if (this.state.roleId!=0) {
			this.setState({
				opts: ['编辑角色']
			})
			//根据传过来的index，获取特定的值，并赋值给detail
			var newDetail=this.state.rows[this.state.roleId-1];
			this.setState({
				detail:newDetail
			})
		}
	}
	
	
	cancelHandle(){
		hashHistory.goBack();
	}
	submitHandle(){
		const {validateFields, getFieldsValue} = this.props.form;
		
		validateFields((errors) => {//表单校验
			if (errors) {
				return
			}//表单校验有误，则不执行下面的代码
			const data = {
				...getFieldsValue() //获取用户输入
			};
			// console.log(`你正在提交数据：${JSON.stringify(data)}`);
			hashHistory.goBack();
		})
		
	}
	render () {
		const { opts, detail} = this.state;
		const {getFieldDecorator} = this.props.form;
		return <div className='dms-body'>
			<DmsTab options={opts} defaultKey={0}>
				<Button onClick={this.cancelHandle.bind(this)}>取消</Button>
				<Button type='primary' onClick={this.submitHandle.bind(this)}>保存</Button>
			</DmsTab>
			<div className="dms-table-box" style={{backgroundColor:"#fff"}}>
				<Form layout="horizontal" >
					<Row gutter={16}>
						<Col className="gutter-row" span={12}>
							<FormItem label="角色" hasFeedback>
								{getFieldDecorator('name', {
									initialValue: (detail !== null && detail.name) ? detail.name : '',
									rules: [
										{
											required: true,
											message: '请输入角色名称'
										},
									],
								})(<Input placeholder="请输入角色名称"/>)}
							</FormItem>
						</Col>
						<Col className="gutter-row" span={12}>
							<FormItem label="编码" hasFeedback>
								{getFieldDecorator('code', {
									initialValue: (detail !== null && detail.code) ? detail.code : '',
									rules: [
										{
											required: true,
											message: '请输入角色编码'
										},
									],
								})(<Input placeholder="请输入角色编码"/>)}
							</FormItem>
						</Col>
					</Row>
					
					<Row>
						<FormItem label="描述">
							{getFieldDecorator('description', {
								initialValue: (detail !== null && detail.description) ? detail.description : ''
							})(<TextArea rows={4}/>)}
						</FormItem>
					</Row>
					
					<Row gutter={16}>
						<Col className="gutter-row" span={12}>
							<FormItem label="状态">
								{getFieldDecorator('active', {
									initialValue: (detail !== null && detail.active===0) ? "无效" : '有效',
									rules: [
										{
											required: true,
											message: '请选择是否有效'
										},
									]
								})(<Select>
									<Option value='1'>有效</Option>
									<Option value='0'>无效</Option>
								</Select>)}
							</FormItem>
						</Col>
					</Row>
					
				</Form>
			</div>
		</div>
	}
}
export default Form.create()(Regionadd)


// WEBPACK FOOTER //
// ./src/routes/role/add.js